<script setup lang="ts">
  import { ref } from "vue";
  import { Text, IconBasket } from "@ui-kit";

  const {
    image,
    name,
    article,
    color,
    visibleDeleteButton = true,
  } = defineProps<{
    image: string;
    name: string;
    article: string;
    color: string;
    visibleDeleteButton?: boolean;
  }>();
  const emit = defineEmits<{ "click:delete": [value: void] }>();

  const visibleNotFoundImage = ref(false);
</script>

<template>
  <div class="add-product-item">
    <div class="add-product-item__content">
      <div class="add-product-item__image">
        <img v-if="!image || visibleNotFoundImage" :src="'/image2.png'" />
        <img v-else :src="'//' + image" @error="visibleNotFoundImage = true" />
      </div>
      <div class="add-product-item__info">
        <Text font="body-medium-16" :wrap="false">{{ name }}</Text>
        <Text font="body-regular-14" color="secondary" :wrap="false">{{ article }}, {{ color }}</Text>
      </div>
    </div>
    <div
      v-if="visibleDeleteButton"
      class="add-product-item__delete"
      @click="emit('click:delete')"
      data-testid="product-item-delete"
    >
      <IconBasket style="stroke: var(--sf-base-icon-error)" />
    </div>
  </div>
</template>

<style scoped>
  .add-product-item {
    display: flex;
    border-radius: 12px;
    width: 100%;
    border: 1px solid var(--sf-base-border-secondary);
    background-color: var(--sf-base-background-white);
    overflow: hidden;
    flex-shrink: 0;
  }

  .add-product-item__content {
    display: flex;
    flex: 1;
    padding: 11px 12px;
    gap: 12px;
    align-items: center;
    overflow: hidden;
  }

  .add-product-item__image {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    width: 50px;
    height: 56px;
    overflow: hidden;
    border-radius: 8px;
  }

  .add-product-item__image img {
    width: 100%;
  }

  .add-product-item__info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    overflow: hidden;
  }

  .add-product-item__info :deep(.text) {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .add-product-item__delete {
    display: flex;
    padding: 28px 8px;
    background-color: var(--sf-base-background-error);
  }
</style>
